import React from 'react';
import ApplyOnline from '../components/ApplyOnline';
import Footer from '../components/Footer';

function ApplyOnlinePage() {
  return (
    <>
      <ApplyOnline />
      <Footer />
    </>
  );
}

export default ApplyOnlinePage;
